import { Box, styled } from '@mui/material';
import { ManagementSectionBody, ManagementSectionContainer } from '../styles';

export const AbsenceSectionContainer = styled(ManagementSectionContainer)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  borderRadius: '4px',
}));

export const AbsenceSectionBody = styled(ManagementSectionBody)({
  padding: 0,
});

export const AbsenceToolbar = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'flex-end',
  justifyContent: 'space-between',
  gap: '16px',
  flexWrap: 'wrap',
  minHeight: '66px',
}));

export const AbsenceSearchWrapper = styled(Box)(({ theme }) => ({
  width: '360px',
  maxWidth: '100%',
  '& .MuiTextField-root': {
    width: '100%',
  },
  '& .MuiOutlinedInput-root': {
    backgroundColor: theme.palette.common.white,
  },
}));

export const AbsenceContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
}));

/** Shown instead of the Edit button on a deactivated row: plain light-grey capitals, no pill. */
export const DeactivatedLabel = styled('span')(({ theme }) => ({
  fontSize: '12px',
  fontWeight: 600,
  letterSpacing: '0.5px',
  textTransform: 'uppercase',
  color: theme.palette.secondary.main,
}));

/** The panel's form fields, 24px apart; the section keeps its own spacing for title and divider. */
export const PanelFields = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
  '& .MuiTextField-root': {
    height: 'auto',
  },
}));

export const PanelFieldRow = styled(Box)(() => ({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: '24px',
}));

export const PanelErrorRow = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  alignItems: 'flex-start',
}));

/** Underlined text button, same look as the contract detail panel's LinkButton. */
export const PanelLinkButton = styled('button')(() => ({
  alignSelf: 'flex-start',
  // Breathing room from the fields above and the card's bottom edge.
  margin: '8px 0',
  background: 'none',
  border: 'none',
  padding: 0,
  cursor: 'pointer',
  textDecoration: 'underline',
  fontSize: '14px',
  color: '#303c42',
  fontFamily: "'Montserrat', sans-serif",
  '&:disabled': {
    cursor: 'default',
    opacity: 0.5,
  },
}));
